/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect, useState, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../component/button";
import classes from "./order.module.css";
import DialogContent from "@mui/material/DialogContent";
import Input from "../../../component/inputpm";
import Loader from "../../../component/loader";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import GenericBPMNForm from "../../../component/genericBPMNForm/genericBPMNForm";
import { Divider, Grid, Box } from "@mui/material";
import bpmnFormValidator from "../../../helper/bpmnFormValidator";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import Draggable from "react-draggable";
import { Paper, Tooltip, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Collapse,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import jp from "jsonpath";
import Chip from "@mui/material/Chip";
import TableContainer from "@mui/material/TableContainer";
// import { makeStyles, withStyles } from '@mui/styles';
import { DeleteIconNew } from "../../../component/icons/icons";
import DialogContentText from "@mui/material/DialogContentText";
import { AddIcon } from "../../../component/icons/icons";
import { TextField } from "@mui/material";

// const StyledIconButton = withStyles({
//     root: {
//         "&$disabled": {
//             color: "#999 !important"
//         },
//         "&$disabled svg": {
//             color: "#999 !important",
//         }
//     },
//     disabled: {}   // <-- must be defined for &$disabled to work
// })(IconButton);

// Get order props from parent (View Order page)
const PartialOrderProcessingDialog = (props) => {
  const t = props.t;
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState({});
  const [error, setError] = useState("");
  const [csvError, setCsvError] = useState("");
  const [quantityData, setQuantityData] = useState([]);

  // const useStyles = makeStyles({
  //     resizablePaper: {
  //         resize: 'both',
  //         overflow: 'auto',
  //         minWidth: 640,
  //         minHeight: 200,
  //         maxWidth: '90vw',
  //         maxHeight: '90vh',
  //         width: '60vw',
  //     },
  //     resizableDeletePaper: {
  //         resize: 'both',
  //         overflow: 'auto',
  //         minWidth: 640,
  //         minHeight: 200,
  //         maxWidth: '90vw',
  //         maxHeight: '90vh',
  //         width: '0',
  //     }
  // });
  // const classess = useStyles();
  useEffect(() => {
    var tempData = JSON.parse(props.data);
    // var tempData = {
    //   "identifiersDetail": [
    //     {
    //       "quantityOrdered": 100,
    //       "productCode": "Auto-Adv-01",
    //       "quantityInProgress": 10,
    //       "packageId": "SOI7570092_0",
    //       "quantityAvailable": 90,
    //       "productName": "Automation Advanced - Cars, Mini Truck Packages - OBD- Ooredoo Fleet Premium+",
    //       "quantityFulfilled": 0,
    //       "bpmnProcessInstanceId": "6de3dcd9-c5d9-11f0-9e6f-34cff6588086",
    //       "identifiersDetail": [
    //         {
    //           "identifiers": [
    //             {
    //               "validationText": "Enter a valid mobile number",
    //               "name": "msisdn",
    //               "label": "MSISDN",
    //               "value": "7382930293",
    //               "required": true,
    //               "validation": "^\\+?[1-9]\\d{1,14}$"
    //             },
    //             {
    //               "validationText": "Enter exactly 15 digits.",
    //               "name": "imeiNumber",
    //               "label": "IMEI Number",
    //               "value": "902938019283920",
    //               "required": false,
    //               "validation": "^[0-9]{15}$"
    //             }
    //           ],
    //           "packageIndex": "10251-1-14",
    //           "statusDetail": "{\"msisdnProvisioned\":true,\"auth\":true,\"bindingResponse\":\"\",\"msisdnProvisionResponse\":\"{\\n              \\\"id\\\": 231029,\\n              \\\"href\\\": \\\"Req_IOTPL_Provision_MSISDN\\\",\\n              \\\"externalId\\\": \\\"CUST_ORDER_456789\\\",\\n              \\\"priority\\\": \\\"1\\\",\\n              \\\"description\\\": \\\"New subscription for IOT Monthly Data Offer with MSISDN assignment.\\\",\\n              \\\"requestedCompletionDate\\\": \\\"1761885793959\\\",\\n              \\\"orderDate\\\": \\\"1761885793959\\\",\\n              \\\"state\\\": \\\"acknowledged\\\",\\n              \\\"relatedParty\\\": [{\\\"id\\\":\\\"8.200009801\\\",\\\"role\\\":\\\"Customer\\\",\\\"@referredType\\\":\\\"Customer\\\"}],\\n              \\\"productOrderItem\\\": [{\\\"action\\\":\\\"add\\\",\\\"quantity\\\":1,\\\"productOffering\\\":{\\\"id\\\":\\\"IotProductOfferingId123\\\",\\\"name\\\":\\\"IOT Monthly Data Offer\\\",\\\"@referredType\\\":\\\"ProductOffering\\\"},\\\"product\\\":{\\\"productCharacteristic\\\":[{\\\"name\\\":\\\"MSISDN\\\",\\\"valueType\\\":\\\"String\\\",\\\"value\\\":\\\"9647704534452\\\"}]}}]\\n            }\\n\",\"msisdnBindUnbind\":false}",
    //           "status": "FAILED"
    //         },
    //         {
    //           "identifiers": [
    //             {
    //               "validationText": "Enter a valid mobile number",
    //               "name": "msisdn",
    //               "label": "MSISDN",
    //               "value": "7382930291",
    //               "required": true,
    //               "validation": "^\\+?[1-9]\\d{1,14}$"
    //             },
    //             {
    //               "validationText": "Enter exactly 15 digits.",
    //               "name": "imeiNumber",
    //               "label": "IMEI Number",
    //               "value": "902938019283921",
    //               "required": false,
    //               "validation": "^[0-9]{15}$"
    //             }
    //           ],
    //           "packageIndex": "10251-1-15",
    //           "statusDetail": "{\"msisdnProvisioned\":true,\"auth\":true,\"bindingResponse\":\"\",\"msisdnProvisionResponse\":\"{\\n              \\\"id\\\": 231029,\\n              \\\"href\\\": \\\"Req_IOTPL_Provision_MSISDN\\\",\\n              \\\"externalId\\\": \\\"CUST_ORDER_456789\\\",\\n              \\\"priority\\\": \\\"1\\\",\\n              \\\"description\\\": \\\"New subscription for IOT Monthly Data Offer with MSISDN assignment.\\\",\\n              \\\"requestedCompletionDate\\\": \\\"1761885793959\\\",\\n              \\\"orderDate\\\": \\\"1761885793959\\\",\\n              \\\"state\\\": \\\"acknowledged\\\",\\n              \\\"relatedParty\\\": [{\\\"id\\\":\\\"8.200009801\\\",\\\"role\\\":\\\"Customer\\\",\\\"@referredType\\\":\\\"Customer\\\"}],\\n              \\\"productOrderItem\\\": [{\\\"action\\\":\\\"add\\\",\\\"quantity\\\":1,\\\"productOffering\\\":{\\\"id\\\":\\\"IotProductOfferingId123\\\",\\\"name\\\":\\\"IOT Monthly Data Offer\\\",\\\"@referredType\\\":\\\"ProductOffering\\\"},\\\"product\\\":{\\\"productCharacteristic\\\":[{\\\"name\\\":\\\"MSISDN\\\",\\\"valueType\\\":\\\"String\\\",\\\"value\\\":\\\"9647704534452\\\"}]}}]\\n            }\\n\",\"msisdnBindUnbind\":false}",
    //           "status": "PENDING"
    //         },
    //         {
    //           "identifiers": [
    //             {
    //               "validationText": "Enter a valid mobile number",
    //               "name": "msisdn",
    //               "label": "MSISDN",
    //               "value": "7382930292",
    //               "required": true,
    //               "validation": "^\\+?[1-9]\\d{1,14}$"
    //             },
    //             {
    //               "validationText": "Enter exactly 15 digits.",
    //               "name": "imeiNumber",
    //               "label": "IMEI Number",
    //               "value": "902938019283922",
    //               "required": false,
    //               "validation": "^[0-9]{15}$"
    //             }
    //           ],
    //           "packageIndex": "10251-1-16",
    //           "statusDetail": "{\"msisdnProvisioned\":true,\"auth\":true,\"bindingResponse\":\"\",\"msisdnProvisionResponse\":\"{\\n              \\\"id\\\": 231029,\\n              \\\"href\\\": \\\"Req_IOTPL_Provision_MSISDN\\\",\\n              \\\"externalId\\\": \\\"CUST_ORDER_456789\\\",\\n              \\\"priority\\\": \\\"1\\\",\\n              \\\"description\\\": \\\"New subscription for IOT Monthly Data Offer with MSISDN assignment.\\\",\\n              \\\"requestedCompletionDate\\\": \\\"1761885793959\\\",\\n              \\\"orderDate\\\": \\\"1761885793959\\\",\\n              \\\"state\\\": \\\"acknowledged\\\",\\n              \\\"relatedParty\\\": [{\\\"id\\\":\\\"8.200009801\\\",\\\"role\\\":\\\"Customer\\\",\\\"@referredType\\\":\\\"Customer\\\"}],\\n              \\\"productOrderItem\\\": [{\\\"action\\\":\\\"add\\\",\\\"quantity\\\":1,\\\"productOffering\\\":{\\\"id\\\":\\\"IotProductOfferingId123\\\",\\\"name\\\":\\\"IOT Monthly Data Offer\\\",\\\"@referredType\\\":\\\"ProductOffering\\\"},\\\"product\\\":{\\\"productCharacteristic\\\":[{\\\"name\\\":\\\"MSISDN\\\",\\\"valueType\\\":\\\"String\\\",\\\"value\\\":\\\"9647704534452\\\"}]}}]\\n            }\\n\",\"msisdnBindUnbind\":false}",
    //           "status": "PENDING"
    //         },
    //         {
    //           "identifiers": [
    //             {
    //               "validationText": "Enter a valid mobile number",
    //               "name": "msisdn",
    //               "label": "MSISDN",
    //               "value": "7382930290",
    //               "required": true,
    //               "validation": "^\\+?[1-9]\\d{1,14}$"
    //             },
    //             {
    //               "validationText": "Enter exactly 15 digits.",
    //               "name": "imeiNumber",
    //               "label": "IMEI Number",
    //               "value": "902938019283923",
    //               "required": false,
    //               "validation": "^[0-9]{15}$"
    //             }
    //           ],
    //           "packageIndex": "10251-1-17",
    //           "statusDetail": "{\"msisdnProvisioned\":true,\"auth\":true,\"bindingResponse\":\"\",\"msisdnProvisionResponse\":\"{\\n              \\\"id\\\": 231029,\\n              \\\"href\\\": \\\"Req_IOTPL_Provision_MSISDN\\\",\\n              \\\"externalId\\\": \\\"CUST_ORDER_456789\\\",\\n              \\\"priority\\\": \\\"1\\\",\\n              \\\"description\\\": \\\"New subscription for IOT Monthly Data Offer with MSISDN assignment.\\\",\\n              \\\"requestedCompletionDate\\\": \\\"1761885793959\\\",\\n              \\\"orderDate\\\": \\\"1761885793959\\\",\\n              \\\"state\\\": \\\"acknowledged\\\",\\n              \\\"relatedParty\\\": [{\\\"id\\\":\\\"8.200009801\\\",\\\"role\\\":\\\"Customer\\\",\\\"@referredType\\\":\\\"Customer\\\"}],\\n              \\\"productOrderItem\\\": [{\\\"action\\\":\\\"add\\\",\\\"quantity\\\":1,\\\"productOffering\\\":{\\\"id\\\":\\\"IotProductOfferingId123\\\",\\\"name\\\":\\\"IOT Monthly Data Offer\\\",\\\"@referredType\\\":\\\"ProductOffering\\\"},\\\"product\\\":{\\\"productCharacteristic\\\":[{\\\"name\\\":\\\"MSISDN\\\",\\\"valueType\\\":\\\"String\\\",\\\"value\\\":\\\"9647704534452\\\"}]}}]\\n            }\\n\",\"msisdnBindUnbind\":false}",
    //           "status": "PENDING"
    //         }
    //       ]
    //     }
    //   ]
    // }
    tempData.identifiersDetail = tempData.identifiersDetail.map((pkg) => ({
      ...pkg,
      quantity: pkg.identifiersDetail ? pkg.identifiersDetail.length : 0,
      oldQuantity: pkg.identifiersDetail ? pkg.identifiersDetail.length : 0,
      maxQuantity:
        (pkg.identifiersDetail ? pkg.identifiersDetail.length : 0) +
        pkg.quantityAvailable,
    }));
    setTableData(tempData);
    setQuantityData(JSON.parse(props.quantityData));
  }, []);

  const fileInputRef = useRef(null);

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [showClearConfirmDialog, setShowClearConfirmDialog] = useState(false);

  const hasExistingValues = () => {
    return tableData.identifiersDetail?.some((item) =>
      item.identifiersDetail?.some((row) =>
        row.identifiers?.some((identifier) => identifier.value),
      ),
    );
  };

  const handleImportClick = () => {
    if (hasExistingValues()) {
      setShowConfirmDialog(true);
    } else {
      // document.getElementById('csv-file-upload').click();
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      fileInputRef.current.click();
    }
  };

  const submitForm = () => {
    var tempTableData = { ...tableData };
    var payload = {
      packageIds: [],
    };
    var tempIndntifiersData = tempTableData.identifiersDetail;
    var isValid = true;
    for (var i = 0; i < tempIndntifiersData.length; i++) {
      // if (tempIndntifiersData[i].edit) {
      var obj = {
        packageId: tempIndntifiersData[i].packageId,
        identifiersValue: [],
      };
      for (
        var j = 0;
        j < tempIndntifiersData[i].identifiersDetail.length;
        j++
      ) {
        // if (tempIndntifiersData[i].identifiersDetail[j].edit) {
        for (
          var k = 0;
          k < tempIndntifiersData[i].identifiersDetail[j].identifiers.length;
          k++
        ) {
          if (
            tempIndntifiersData[i].identifiersDetail[j].identifiers[k].value &&
            tempIndntifiersData[i].identifiersDetail[j].identifiers[k].value !==
            ""
          ) {
          } else {
            // setError(tempIndntifiersData[i].identifiersDetail[j].identifiers[k].label + ' is required for line ' + (i + 1));
            // return;
            isValid = false;
            if (
              tempIndntifiersData[i].identifiersDetail[j].identifiers[k]
                .invalidValue
            ) {
            } else {
              tempIndntifiersData[i].identifiersDetail[j].identifiers[
                k
              ].invalidValue = true;
              tempIndntifiersData[i].identifiersDetail[j].identifiers[
                k
              ].errorMessage =
                tempIndntifiersData[i].identifiersDetail[j].identifiers[k]
                  .label + " is required";
            }
          }
          var duplicateValues = jp.query(
            tempIndntifiersData[i],
            '$..[?(@.value=="' +
            tempIndntifiersData[i].identifiersDetail[j].identifiers[k].value +
            '" && @.name=="' +
            tempIndntifiersData[i].identifiersDetail[j].identifiers[k].name +
            '")]',
          );
          if (duplicateValues.length > 1) {
            // setError(props.t('DUPLICATE') + ' ' + tempIndntifiersData[i].identifiersDetail[j].identifiers[k].label + ' found on line ' + (i + 1));
            // return;
            isValid = false;
            tempIndntifiersData[i].identifiersDetail[j].identifiers[
              k
            ].invalidValue = true;
            tempIndntifiersData[i].identifiersDetail[j].identifiers[
              k
            ].errorMessage =
              `Duplicate ${tempIndntifiersData[i].identifiersDetail[j].identifiers[k].label} found`;
          }
          if (
            tempIndntifiersData[i].identifiersDetail[j].identifiers[k]
              .validation
          ) {
            let reg =
              tempIndntifiersData[i].identifiersDetail[j].identifiers[k]
                .validation;
            if (reg) {
              if (reg.charAt(0) === "/") {
                reg = reg.slice(1);
              }
              if (reg.charAt(reg.length - 1) === "/") {
                reg = reg.slice(0, -1);
              }
              var pattern = new RegExp(reg);
              if (
                pattern.test(
                  tempIndntifiersData[i].identifiersDetail[j].identifiers[k]
                    .value,
                )
              ) {
                // console.log('valid data');
              } else {
                // console.log('invalid data');
                // setError(props.t('INVALID_VALUE_ENTERED') + ' for ' + tempIndntifiersData[i].identifiersDetail[j].identifiers[k].label + ' on line ' + (i + 1));
                // return;

                isValid = false;
                if (
                  tempIndntifiersData[i].identifiersDetail[j].identifiers[k]
                    .invalidValue
                ) {
                } else {
                  tempIndntifiersData[i].identifiersDetail[j].identifiers[
                    k
                  ].invalidValue = true;
                  // tempIndntifiersData[i].identifiersDetail[j].identifiers[k].errorMessage = 'Invalid ' + tempIndntifiersData[i].identifiersDetail[j].identifiers[k].label;
                  tempIndntifiersData[i].identifiersDetail[j].identifiers[
                    k
                  ].errorMessage =
                    tempIndntifiersData[i].identifiersDetail[j].identifiers[
                      k
                    ].validationText;
                }
              }
            }
          }
          if (
            tempIndntifiersData[i].identifiersDetail[j].identifiers.length ===
            k + 1
          ) {
            obj.identifiersValue.push({
              packageIndex:
                tempIndntifiersData[i].identifiersDetail[j].packageIndex,
              identifiers:
                tempIndntifiersData[i].identifiersDetail[j].identifiers,
            });
          }
        }
        // }
        if (tempIndntifiersData[i].identifiersDetail.length === j + 1) {
          payload.packageIds.push(obj);
        }
      }
      // }
      if (tempIndntifiersData.length === i + 1) {
        if (payload.packageIds.length > 0) {
          if (isValid) {
            if (props.tenantId) {
              payload.tenantId = props.tenantId;
            }
            console.log("check final edit payload", payload);
            // return;
            setLoading(true);
            BusApiCall(
              "PATCH",
              `${constants.busV44UrlPublic}/orders/${props.orderId}/packageOrderItem/bpmnProcess/${tableData.bpmnProcessInstanceId}`,
              payload,
            )
              .then((res) => {
                console.log("here is the response", res);
                props.close(true);
              })
              .catch((err) => {
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                ) {
                  if (
                    err.response.data.detail &&
                    err.response.data.detail.packageIds &&
                    err.response.data.detail.packageIds.length > 0
                  ) {
                    setIdentifiersErrorData(
                      err.response.data.detail.packageIds,
                      err.response.data.message,
                    );
                  }
                  // const errorMessage = `${err.response.data.detail ? `${err.response.data.detail} : ` : ''}${err.response.data.message || ''}`;
                  // // setError(err.response.data.message);
                  // setError(errorMessage);
                  setLoading(false);
                  // props.setErrorMessage(err.response.data.message, false)
                } else {
                  setError(props.t("DEFAULT_ERROR_MESSAGE"));
                  setLoading(false);
                  // props.setErrorMessage(props.t('DEFAULT_ERROR_MESSAGE'), false)
                }
              });
          } else {
            var tempData = { ...tableData };
            tempData.identifiersDetail = tempIndntifiersData;
            setTableData(tempData);
            console.log("invalid form data found");
          }
        } else {
          setError(props.t("ALL_FIELDS_REQUIRED"));
          setLoading(false);
        }
      }
    }
  };

  const setIdentifiersErrorData = (errorData, msg) => {
    // var data = [{ "packageId": "SOI7575771_0", "identifiersValue": [{ "identifiers": [{ "name": "vinNumber", "value": "1HGCM82663A123458", "required": false, "validValue": true }, { "name": "imeiNumber", "value": "351916023476977", "required": false, "validValue": true }, { "name": "iccid", "value": "8944125236634849493", "required": false, "validValue": true }], "hasValidIdentifiers": false }] }, { "packageId": "SOI7575771_1", "identifiersValue": [{ "identifiers": [{ "name": "vinNumber", "value": "89441252366348494", "required": false, "validValue": true }, { "name": "imeiNumber", "value": "351916023476945", "required": false, "validValue": true }, { "name": "iccid", "value": "8944125236634849489", "required": false, "validValue": true }], "hasValidIdentifiers": false }, { "identifiers": [{ "name": "vinNumber", "value": "89441256634849493", "required": false, "validValue": true }, { "name": "imeiNumber", "value": "351916023476977", "required": false, "validValue": false }, { "name": "iccid", "value": "8944125236634849493", "required": false, "validValue": false }], "hasValidIdentifiers": false }, { "identifiers": [{ "name": "vinNumber", "value": "1HGCM82663A123458", "required": false, "validValue": false }, { "name": "imeiNumber", "value": "351916023476977", "required": false, "validValue": false }, { "name": "iccid", "value": "8944125236634849493", "required": false, "validValue": false }], "hasValidIdentifiers": false }, { "identifiers": [{ "name": "vinNumber", "value": "89441252366348494", "required": false, "validValue": false }, { "name": "imeiNumber", "value": "351916023476977", "required": false, "validValue": false }, { "name": "iccid", "value": "8944125236634849493", "required": false, "validValue": false }], "hasValidIdentifiers": false }] }];
    var data = errorData;
    var tempTableData = { ...tableData };

    const detailsMap = {};

    // Flatten errorData invalid identifiers
    data.forEach((pkg) => {
      pkg.identifiersValue.forEach((group) => {
        group.identifiers.forEach((iden) => {
          if (!iden.validValue) {
            const key = `${pkg.packageId}-${iden.name}-${iden.value}`;
            detailsMap[key] = true;
          }
        });
      });
    });

    // Add errorMessage in tempTableData where match found
    tempTableData.identifiersDetail.forEach((pkg) => {
      pkg.identifiersDetail.forEach((group) => {
        group.identifiers.forEach((iden) => {
          const key = `${pkg.packageId}-${iden.name}-${iden.value}`;
          if (detailsMap[key]) {
            if (msg) {
              iden.errorMessage = msg;
            } else {
              iden.errorMessage = `Duplicate ${iden.label} found`;
            }
            iden.invalidValue = true;
          } else {
            iden.errorMessage = "";
            iden.invalidValue = false;
          }
        });
      });
    });

    setTableData(tempTableData);
  };

  const changeMetaData = (e, item, index, fIndex, column) => {
    setError("");
    var data = { ...tableData };
    // var index = data.identifiersDetail.findIndex((x) => x.packageId === item.packageId);
    if (index > -1) {
      var indentifierIndex = data.identifiersDetail[
        index
      ].identifiersDetail.findIndex((y) => y.packageIndex === fIndex);
      // data.identifiersDetail[index].edit = true;

      if (indentifierIndex > -1) {
        var columnIndex = data.identifiersDetail[index].identifiersDetail[
          indentifierIndex
        ].identifiers.findIndex((z) => z.name === column.name);
        if (columnIndex > -1) {
          // data.identifiersDetail[index].identifiersDetail[indentifierIndex].edit = true;
          data.identifiersDetail[index].identifiersDetail[
            indentifierIndex
          ].identifiers[columnIndex].value = e.target.value;
          data.identifiersDetail[index].identifiersDetail[
            indentifierIndex
          ].identifiers[columnIndex].invalidValue = false;
          data.identifiersDetail[index].identifiersDetail[
            indentifierIndex
          ].identifiers[columnIndex].errorMessage = "";
          setTableData(data);
        }
      }
    }
  };
  const [rowToDelete, setRowToDelete] = useState({});
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  const [selectedProductToDelete, setSelectedProductToDelete] = useState({});
  const deleteMetaData = (e, item, index, packageIndex) => {
    setSelectedProductToDelete({ ...item, index: index });
    var obj = {
      packageId: item.packageId,
      packageIndex: packageIndex,
      action: "DELETE",
      quantity: 1,
      orderStatusId: tableData.orderHistoryId,
    };
    if (props.tenantId) {
      obj.tenantId = props.tenantId;
    }
    setRowToDelete(obj);
    setShowDeleteWarning(true);
  };

  const closeDeleteDialog = (value) => {
    if (value) {
      var tempTableData = { ...tableData };
      setLoading(true);
      BusApiCall(
        "PATCH",
        `${constants.busV44UrlPublic}/orders/${props.orderId}/itemFulfillment/bpmnProcess/${tableData.bpmnProcessInstanceId}`,
        rowToDelete,
      )
        .then((res) => {
          for (var i = 0; i < tempTableData.identifiersDetail.length; i++) {
            if (
              tempTableData.identifiersDetail[i].packageId ===
              rowToDelete.packageId
            ) {
              for (
                var j = 0;
                j < tempTableData.identifiersDetail[i].identifiersDetail.length;
                j++
              ) {
                if (
                  tempTableData.identifiersDetail[i].identifiersDetail[j]
                    .packageIndex === rowToDelete.packageIndex
                ) {
                  tempTableData.identifiersDetail[i].identifiersDetail.splice(
                    j,
                    1,
                  );
                  setTableData(tempTableData);
                  setRowToDelete({});
                  setSelectedProductToDelete({});
                  setShowDeleteWarning(false);
                  setLoading(false);
                  props.reloadPartialOrderProcessingData(tempTableData);
                }
              }
            }
          }
        })
        .catch((err) => {
          setRowToDelete({});
          setSelectedProductToDelete({});
          setShowDeleteWarning(false);
          if (err.response && err.response.data && err.response.data.message) {
            const errorMessage = `${err.response.data.detail ? `${err.response.data.detail} : ` : ""}${err.response.data.message || ""}`;
            // setError(err.response.data.message);
            setError(errorMessage);
            setLoading(false);
            // props.setErrorMessage(err.response.data.message, false)
          } else {
            setError(props.t("DEFAULT_ERROR_MESSAGE"));
            setLoading(false);
            // props.setErrorMessage(props.t('DEFAULT_ERROR_MESSAGE'), false)
          }
        });
    } else {
      setRowToDelete({});
      setSelectedProductToDelete({});
      setShowDeleteWarning(false);
    }
  };

  const toogleExpandRow = (e, item, index, packageIndex) => {
    var tempTableData = { ...tableData };
    var obj = {
      packageId: item.packageId,
      packageIndex: packageIndex,
      action: "DELETE",
      quantity: 1,
      orderStatusId: tableData.orderHistoryId,
    }
    for (var i = 0; i < tempTableData.identifiersDetail.length; i++) {
      if (
        tempTableData.identifiersDetail[i].packageId ===
        obj.packageId
      ) {
        for (
          var j = 0;
          j < tempTableData.identifiersDetail[i].identifiersDetail.length;
          j++
        ) {
          if (
            tempTableData.identifiersDetail[i].identifiersDetail[j]
              .packageIndex === obj.packageIndex
          ) {
            if (tempTableData.identifiersDetail[i].identifiersDetail[j].expand) {
              tempTableData.identifiersDetail[i].identifiersDetail[j].expand = false;
            } else {
              tempTableData.identifiersDetail[i].identifiersDetail[j].expand = true;
            }
            setTableData(tempTableData);
          }
        }
      }
    }
  }

  const handleCSVUpload = (event) => {
    setCsvError("");
    const file = event.target.files[0];
    if (!file) return;

    if (!file.name.endsWith(".csv")) {
      setCsvError(t("PLEASE_UPLOAD_CSV_FILE"));
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const text = e.target.result;
        const rows = text
          .split("\n")
          .map((row) => row.trim())
          .filter((row) => row);
        if (rows.length <= 1) {
          setCsvError(t("CSV_FILE_IS_EMPTY"));
          return;
        }
        const headers = rows[0].split(",").map((h) => h.trim().toLowerCase());

        // Calculate the total number of form rows
        let totalFormRows = 0;
        tableData.identifiersDetail.forEach((item) => {
          totalFormRows += item.identifiersDetail.length;
        });

        // Check if CSV data rows match form rows
        const csvDataRows = rows.length - 1; // Subtract header row
        if (csvDataRows !== totalFormRows) {
          setCsvError(
            t("CSV_RECORD_COUNT_MISMATCH", {
              csvRows: csvDataRows,
              formRows: totalFormRows,
            }),
          );
          return;
        }

        //getting all column names from the form
        const requiredColumns = new Set();
        tableData.identifiersDetail.forEach((item) => {
          item.identifiersDetail.forEach((identifierRow) => {
            identifierRow.identifiers.forEach((identifier) => {
              requiredColumns.add(identifier.name.toLowerCase());
            });
          });
        });

        // Check for missing columns
        const missingColumns = Array.from(requiredColumns).filter(
          (column) => !headers.includes(column.toLowerCase()),
        );

        if (missingColumns.length > 0) {
          console.log(
            "missing columns",
            missingColumns,
            requiredColumns,
            headers,
          );
          setCsvError(
            t("MISSING_CSV_COLUMNS", {
              columns: missingColumns.join(", "),
            }),
          );
          return;
        }

        // Create a map of column names to their indices
        const headerMap = {};
        headers.forEach((header, index) => {
          headerMap[header.toLowerCase()] = index;
        });

        const data = { ...tableData };
        let csvRowIndex = 1; // Start after header row

        // Match CSV rows to form rows
        data.identifiersDetail.forEach((item) => {
          item.identifiersDetail.forEach((identifierRow) => {
            if (csvRowIndex < rows.length) {
              const values = rows[csvRowIndex].split(",").map((v) => v.trim());

              // Update identifiers with values from this CSV row
              identifierRow.identifiers.forEach((identifier) => {
                const columnIndex = headerMap[identifier.name.toLowerCase()];
                if (columnIndex !== undefined) {
                  identifier.value = values[columnIndex];
                }
              });
              csvRowIndex++;
            }
          });
        });

        setTableData(data);
      } catch (error) {
        console.error("CSV processing error:", error);
        setCsvError(t("ERROR_PROCESSING_CSV_FILE"));
      }
    };
    reader.readAsText(file);
  };
  //uncomment this Import CSV feature for future release - we use offering code for mapping csv entries
  // const handleCSVUpload = (event) => {
  //     setCsvError('');
  //     const file = event.target.files[0];
  //     if (!file) return;

  //     if (!file.name.endsWith('.csv')) {
  //         setCsvError(t('PLEASE_UPLOAD_CSV_FILE'));
  //         return;
  //     }
  //     // console.log('tableData', tableData);
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //         try {
  //             const text = e.target.result;
  //             const rows = text.split('\n').map(row => row.trim()).filter(row => row);
  //             if (rows.length <= 1) {
  //                 setCsvError(t('CSV_FILE_IS_EMPTY'));
  //                 return;
  //             }
  //             const headers = rows[0].split(',').map(h => h.trim().toLowerCase());

  //         // Check if productCode column exists in CSV
  //         const productCodeIndex = headers.findIndex(h =>
  //             h === 'productcode' || h === 'offeringcode' || h === 'product code' || h === 'offering code');

  //         if (productCodeIndex === -1) {
  //             setCsvError(t('CSV_MISSING_PRODUCT_CODE_COLUMN'));
  //             return;
  //         }

  //         // Getting all column names from the form
  //         const requiredColumns = new Set();
  //         tableData.identifiersDetail.forEach(item => {
  //             item.identifiersDetail.forEach(identifierRow => {
  //                 identifierRow.identifiers.forEach(identifier => {
  //                     requiredColumns.add(identifier.name.toLowerCase());
  //                 });
  //             });
  //         });

  //         const missingColumns = Array.from(requiredColumns).filter(
  //             column => !headers.includes(column.toLowerCase())
  //         );

  //         if (missingColumns.length > 0) {
  //             console.log('missing columns', missingColumns, requiredColumns, headers);
  //             setCsvError(t('MISSING_CSV_COLUMNS', {
  //                 columns: missingColumns.join(', ')
  //             }));
  //             return;
  //         }

  //         // Create a map of column names to their indices
  //         const headerMap = {};
  //         headers.forEach((header, index) => {
  //             headerMap[header.toLowerCase()] = index;
  //         });

  //         // Create a map of product codes to arrays of CSV rows
  //         const csvRowsByProductCode = {};
  //         for (let i = 1; i < rows.length; i++) {
  //             const rowValues = rows[i].split(',').map(v => v.trim());
  //             const productCode = rowValues[productCodeIndex];
  //             if (productCode) {
  //                 if (!csvRowsByProductCode[productCode]) {
  //                     csvRowsByProductCode[productCode] = [];
  //                 }
  //                 csvRowsByProductCode[productCode].push(rowValues);
  //             }
  //         }

  //         const data = { ...tableData };

  //         const usedRowIndexes = {};

  //         data.identifiersDetail.forEach(item => {
  //             const productCode = item.productCode;
  //             if (!productCode || !csvRowsByProductCode[productCode]) return;

  //             if (!usedRowIndexes[productCode]) {
  //                 usedRowIndexes[productCode] = 0;
  //             }

  //             const csvRowsForProduct = csvRowsByProductCode[productCode];
  //             if (usedRowIndexes[productCode] < csvRowsForProduct.length) {
  //                 const csvValues = csvRowsForProduct[usedRowIndexes[productCode]];

  //                 item.identifiersDetail.forEach(identifierRow => {
  //                     identifierRow.identifiers.forEach(identifier => {
  //                         const columnIndex = headerMap[identifier.name.toLowerCase()];
  //                         if (columnIndex !== undefined && csvValues[columnIndex]) {
  //                             identifier.value = csvValues[columnIndex];
  //                         }
  //                     });
  //                 });

  //                 usedRowIndexes[productCode]++;
  //             }
  //         });

  //         setTableData(data);
  //         } catch (error) {
  //             console.error('CSV processing error:', error);
  //             setCsvError(t('ERROR_PROCESSING_CSV_FILE'));
  //         }
  //     };
  //     reader.readAsText(file);
  // };

  const handleClearClick = () => {
    if (hasExistingValues()) {
      setShowClearConfirmDialog(true);
    } else {
      clearAllFields();
    }
  };

  const clearAllFields = () => {
    const data = { ...tableData };
    data.identifiersDetail.forEach((item) => {
      item.identifiersDetail.forEach((identifierRow) => {
        identifierRow.identifiers.forEach((identifier) => {
          identifier.value = "";
        });
      });
    });
    setTableData(data);
    setError("");
    setCsvError("");

    const csvFileInput = document.getElementById("csv-file-upload");
    if (csvFileInput) {
      csvFileInput.value = "";
    }
  };

  const enableQuantityInput = (e, item) => {
    var index = tableData.identifiersDetail.findIndex(
      (x) => x.packageId === item.packageId,
    );
    if (index > -1) {
      var data = { ...tableData };
      data.identifiersDetail[index].enableQuantity = true;
      setTableData(data);
    }
  };

  const changeOfferingQuantity = (e, item) => {
    var index = tableData.identifiersDetail.findIndex(
      (x) => x.packageId === item.packageId,
    );
    if (index > -1) {
      var data = { ...tableData };
      if (e.target.value > data.identifiersDetail[index].maxQuantity) {
        data.identifiersDetail[index].quantity =
          data.identifiersDetail[index].maxQuantity;
      } else {
        if (e.target.value === "" || +e.target.value > 0) {
          data.identifiersDetail[index].quantity = e.target.value;
          setTableData(data);
        }
      }
    }
  };

  const cancelQuantityUpdate = (e, item, newQuantity) => {
    var index = tableData.identifiersDetail.findIndex(
      (x) => x.packageId === item.packageId,
    );
    if (index > -1) {
      var data = { ...tableData };
      data.identifiersDetail[index].quantity = newQuantity
        ? newQuantity
        : data.identifiersDetail[index].oldQuantity;
      data.identifiersDetail[index].enableQuantity = false;
      setTableData(data);
    }
  };

  const updateOfferingQuantity = (e, item) => {
    if (item.quantity && item.quantity !== "" && +item.quantity > 0) {
      if (item.quantity <= item.maxQuantity) {
        var payload = {
          packageId: item.packageId,
          action: "MODIFY",
          quantity: +item.quantity,
          orderStatusId: tableData.orderHistoryId,
          currentQty: item.identifiersDetail.length,
        };
        if (props.tenantId) {
          payload.tenantId = props.tenantId;
        }
        console.log("check final item data", payload);
        setLoading(true);
        BusApiCall(
          "PATCH",
          `${constants.busV44UrlPublic}/orders/${props.orderId}/itemFulfillment/bpmnProcess/${tableData.bpmnProcessInstanceId}`,
          payload,
        )
          .then((res) => {
            cancelQuantityUpdate(e, item, item.quantity);
            setLoading(false);
            props.reloadPartialOrderProcessingData(tableData);
          })
          .catch((err) => {
            setShowDeleteWarning(false);
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              const errorMessage = `${err.response.data.detail ? `${err.response.data.detail} : ` : ""}${err.response.data.message || ""}`;
              // setError(err.response.data.message);
              setError(errorMessage);
              setLoading(false);
              // props.setErrorMessage(err.response.data.message, false)
            } else {
              setError(props.t("DEFAULT_ERROR_MESSAGE"));
              setLoading(false);
              // props.setErrorMessage(props.t('DEFAULT_ERROR_MESSAGE'), false)
            }
          });
      }
    }
  };

  const addRowToOffering = (e, item) => {
    var payload = {
      packageId: item.packageId,
      action: "ADD",
      quantity: 1,
      orderStatusId: tableData.orderHistoryId,
    };
    if (props.tenantId) {
      payload.tenantId = props.tenantId;
    }
    setLoading(true);
    BusApiCall(
      "PATCH",
      `${constants.busV44UrlPublic}/orders/${props.orderId}/itemFulfillment/bpmnProcess/${tableData.bpmnProcessInstanceId}`,
      payload,
    )
      .then((res) => {
        cancelQuantityUpdate(e, item);
        setLoading(false);
        props.reloadPartialOrderProcessingData(tableData);
      })
      .catch((err) => {
        setShowDeleteWarning(false);
        if (err.response && err.response.data && err.response.data.message) {
          const errorMessage = `${err.response.data.detail ? `${err.response.data.detail} : ` : ""}${err.response.data.message || ""}`;
          // setError(err.response.data.message);
          setError(errorMessage);
          setLoading(false);
          // props.setErrorMessage(err.response.data.message, false)
        } else {
          setError(props.t("DEFAULT_ERROR_MESSAGE"));
          setLoading(false);
          // props.setErrorMessage(props.t('DEFAULT_ERROR_MESSAGE'), false)
        }
      });
  };

  const [focusedInputs, setFocusedInputs] = useState({});

  const getKey = (rowIdx, subIdx, colIdx) => `${rowIdx}-${subIdx}-${colIdx}`;

  const handleFocus = (rowIdx, subIdx, colIdx) => {
    setFocusedInputs((prev) => ({
      ...prev,
      [getKey(rowIdx, subIdx, colIdx)]: true,
    }));
  };

  const handleBlur = (rowIdx, subIdx, colIdx) => {
    setFocusedInputs((prev) => ({
      ...prev,
      [getKey(rowIdx, subIdx, colIdx)]: false,
    }));
  };

  const deepParseJSON = (obj) => {
    if (typeof obj === "string") {
      try {
        const parsed = JSON.parse(obj);
        return deepParseJSON(parsed); // parse deeper if needed
      } catch (e) {
        return obj; // not JSON, return as-is
      }
    }

    if (Array.isArray(obj)) {
      return obj.map(item => deepParseJSON(item));
    }

    if (typeof obj === "object" && obj !== null) {
      const result = {};
      Object.keys(obj).forEach(key => {
        result[key] = deepParseJSON(obj[key]);
      });
      return result;
    }

    return obj;
  }

  return (
    <React.Fragment>
      <Dialog
        disableScrollLock={true}
        PaperComponent={DraggableDialogPaper}
        open={props.open}
        maxWidth={"md"}
        fullWidth={true}
      // PaperProps={{
      //     className: classess.resizablePaper
      // }}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          <div style={{ display: "flex" }}>
            <span style={{ display: "inline-flex", width: "95%" }}>
              {t("VIEW_FULFILLMENT_DETAILS")}
            </span>
            <Tooltip title={t("CLOSE")}>
              <IconButton
                onTouchStart={() => {
                  props.close(false);
                }}
                onClick={() => {
                  props.close(false);
                }}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={3}>
            {/* <Table> */}
            {tableData &&
              tableData.identifiersDetail &&
              tableData.identifiersDetail.length > 0 &&
              tableData.identifiersDetail.map((item, index) => {
                if (item.identifiersDetail.length > 0) {
                  return (
                    <React.Fragment key={index}>
                      <div className={classes.partialOrderProcessingContainer}>
                        <div
                          style={{
                            padding: "10px",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <b style={{ width: "70%", lineHeight: "30px" }}>
                            {item.productName}
                          </b>
                          <span
                            style={{
                              float: "right",
                              width: "30%",
                              textAlign: "right",
                            }}
                          >
                            {item.status ? (
                              item.status === "ACTIVE" ? (
                                <Chip
                                  size="normal"
                                  className="successChip"
                                  label={props.t(item.status)}
                                />
                              ) : item.status === "FAILED" ? (
                                <Chip
                                  size="normal"
                                  className="errorChip"
                                  label={props.t(item.status)}
                                />
                              ) : (
                                <Chip
                                  size="normal"
                                  className="inProgressChip"
                                  label={props.t(item.status)}
                                />
                              )
                            ) : null}{" "}
                            &nbsp;&nbsp;
                            <>
                              <Tooltip
                                title={
                                  t("MAXIMUM_QUANTITY_AVAILABLE") +
                                  ": " +
                                  item.maxQuantity
                                }
                              >
                                <span>
                                  <Input
                                    className={classes.quantityInput}
                                    type="number"
                                    min="1"
                                    step="1"
                                    name="quantity"
                                    value={item.quantity}
                                    onChange={(e) => {
                                      changeOfferingQuantity(e, item);
                                    }}
                                    style={{ width: "80px", height: "30px" }}
                                    // disabled={item.quantityAvailable === 0 && !item.enableQuantity}
                                    disabled={!item.enableQuantity}
                                    placeholder={t("QUANTITY")}
                                  />
                                </span>
                              </Tooltip>
                              {item.enableQuantity ? (
                                <>
                                  <Button
                                    onClick={(e) =>
                                      updateOfferingQuantity(e, item)
                                    }
                                    style={{ margin: "0 10px" }}
                                  >
                                    {t("SAVE")}
                                  </Button>
                                  <Button
                                    onClick={(e) =>
                                      cancelQuantityUpdate(e, item)
                                    }
                                  >
                                    {t("CANCEL")}
                                  </Button>
                                  {/* <div style={{ paddingRight: '90px', paddingTop: '5px' }}>
                                                                    Available Quantity {item.quantityAvailable}
                                                                </div> */}
                                </>
                              ) : (
                                <Button
                                  onClick={(e) => enableQuantityInput(e, item)}
                                  style={{ marginLeft: "10px" }}
                                >
                                  {t("MODIFY")}
                                </Button>
                              )}
                            </>
                          </span>
                        </div>
                        {/* <div style={{ padding: '1rem', display: 'flex', justifyContent: 'space-between' }}>
                                                    <TableContainer>
                                                        <Table className='newGlobalTable roundCorners'>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align='right' style={{ width: '50px' }}>{t('QUO_ORDERED')}</TableCell>
                                                                    <TableCell align='right' style={{ width: '70px' }}>{t('IN_PROGRESS')}</TableCell>
                                                                    <TableCell align='right' style={{ width: '50px' }}>{t('PENDING')}</TableCell>
                                                                    <TableCell align='right' style={{ width: '50px' }}>{t('COMPLETED')}</TableCell>
                                                                    <TableCell align='right' style={{ width: '100px' }}>{t('FULFILL')}</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                <TableRow>
                                                                    <TableCell align='right'>{item.quantityOrdered}</TableCell>
                                                                    <TableCell align='right'>{item.quantityInProgress}</TableCell>
                                                                    <TableCell align='right'>{item.quantityAvailable}</TableCell>
                                                                    <TableCell align='right'>{item.quantityFulfilled}</TableCell>
                                                                    <TableCell align='right'>
                                                                        {item.enableQuantity ?
                                                                            <>
                                                                                <Input
                                                                                    className={classes.quantityInput}
                                                                                    type="number"
                                                                                    min="1"
                                                                                    step="1"
                                                                                    name="quantity"
                                                                                    value={item.quantity}
                                                                                    onChange={(e) => { changeOfferingQuantity(e, item) }}
                                                                                    style={{ width: '80px' }}
                                                                                    disabled={item.quantityAvailable === 0}
                                                                                />
                                                                                <Button onClick={(e) => updateOfferingQuantity(e, item)} style={{ margin: '0 10px' }}>{t('UPDATE')}</Button>
                                                                                <Button onClick={(e) => cancelQuantityUpdate(e, item)}>{t('CANCEL')}</Button>
                                                                            </>
                                                                            :
                                                                            <Button onClick={(e) => enableQuantityInput(e, item)}>{t('ADD_QUANTITY')}</Button>
                                                                        }
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </div> */}
                        {item.statusDetail && item.statusDetail !== "" && (
                          <div
                            style={{
                              padding: ".5rem 1rem",
                              backgroundColor: "#fee2e2",
                            }}
                          >
                            <div
                              style={{ color: "#991b1b", fontWeight: "bold" }}
                            >
                              {item.statusDetail}
                            </div>
                          </div>
                        )}
                        <Divider />
                        <TableContainer style={{ overflow: "inherit" }}>
                          <Table className="newGlobalTable roundCorners">
                            <TableHead>
                              {/* <TableRow>
                                                        <TableCell colSpan={item.identifiersDetail[0].identifiers.length-1}>
                                                            {item.productName}
                                                            </TableCell>
                                                            <TableCell align='right'>
                                                             {item.status && 
                                                                item.status === 'ACTIVE' ? 
                                                                    <Chip size="normal" className='successChip' label={props.t(item.status)} />
                                                                : item.status === 'FAILED' ?
                                                                    <Chip size="normal" className='errorChip' label={props.t(item.status)} /> 
                                                                :
                                                                    <Chip size="normal" className='inProgressChip' label={props.t(item.status)} />
                                                                }
                                                        </TableCell>
                                                    </TableRow> */}
                            </TableHead>
                            <TableBody>
                              {item.identifiersDetail.map(
                                (identifierRow, subIndex) => (
                                  <React.Fragment key={subIndex}>
                                    <TableRow>
                                      <TableCell
                                        style={{
                                          verticalAlign: "top",
                                          width: "50px",
                                          textAlign: "right",
                                          // borderBottom:
                                          //   item.identifiersDetail.length ===
                                          //     subIndex + 1
                                          //     ? "none"
                                          //     : "",
                                        }}
                                      >
                                        <span style={{ lineHeight: "28.63px" }}>
                                          {subIndex + 1}
                                        </span>
                                      </TableCell>
                                      {identifierRow.identifiers.map(
                                        (column, colIndex) => {
                                          const key = getKey(
                                            index,
                                            subIndex,
                                            colIndex,
                                          );
                                          const isFocused =
                                            !!focusedInputs[key];
                                          return (
                                            <TableCell
                                              style={{
                                                verticalAlign: "top",
                                                // borderBottom:
                                                //   item.identifiersDetail
                                                //     .length ===
                                                //     subIndex + 1
                                                //     ? "none"
                                                //     : "",
                                              }}
                                              key={colIndex}
                                            >
                                              {column.validation ? (
                                                <TextField
                                                  variant="outlined"
                                                  fullWidth
                                                  label={column.label + " *"}
                                                  value={column.value}
                                                  name={column.name}
                                                  onChange={(e) =>
                                                    changeMetaData(
                                                      e,
                                                      item,
                                                      index,
                                                      identifierRow.packageIndex,
                                                      column,
                                                    )
                                                  }
                                                  error={!!column.invalidValue}
                                                  helperText={
                                                    column.errorMessage
                                                  }
                                                  InputLabelProps={{
                                                    shrink:
                                                      isFocused ||
                                                      !!column.value,
                                                  }}
                                                  onFocus={() =>
                                                    handleFocus(
                                                      index,
                                                      subIndex,
                                                      colIndex,
                                                    )
                                                  }
                                                  onBlur={() =>
                                                    handleBlur(
                                                      index,
                                                      subIndex,
                                                      colIndex,
                                                    )
                                                  }
                                                />
                                              ) : (
                                                <TextField
                                                  variant="outlined"
                                                  fullWidth
                                                  label={column.label + " *"}
                                                  value={column.value}
                                                  name={column.name}
                                                  onChange={(e) =>
                                                    changeMetaData(
                                                      e,
                                                      item,
                                                      index,
                                                      identifierRow.packageIndex,
                                                      column,
                                                    )
                                                  }
                                                  error={!!column.invalidValue}
                                                  helperText={
                                                    column.errorMessage
                                                  }
                                                  InputLabelProps={{
                                                    shrink:
                                                      isFocused ||
                                                      !!column.value,
                                                  }}
                                                  oonFocus={() =>
                                                    handleFocus(
                                                      index,
                                                      subIndex,
                                                      colIndex,
                                                    )
                                                  }
                                                  onBlur={() =>
                                                    handleBlur(
                                                      index,
                                                      subIndex,
                                                      colIndex,
                                                    )
                                                  }
                                                />
                                              )}
                                            </TableCell>
                                          );
                                        },
                                      )}
                                      <TableCell style={{
                                        verticalAlign: "top",
                                        width: "120px",
                                        textAlign: 'center'
                                        // borderBottom:
                                        //   item.identifiersDetail.length ===
                                        //     subIndex + 1
                                        //     ? "none"
                                        //     : "",
                                      }}>
                                        {identifierRow.status ? (
                                          identifierRow.status === "ACTIVE" ? (
                                            <Chip
                                              size="normal"
                                              className="successChip"
                                              label={props.t(identifierRow.status)}
                                              style={{ height: '28.63px' }}
                                            />
                                          ) : identifierRow.status === "FAILED" ? (
                                            <Chip
                                              size="normal"
                                              className="errorChip"
                                              label={props.t(identifierRow.status)}
                                              style={{ height: '28.63px' }}
                                            />
                                          ) : (
                                            <Chip
                                              size="normal"
                                              className="inProgressChip"
                                              label={props.t(identifierRow.status)}
                                              style={{ height: '28.63px' }}
                                            />
                                          )
                                        ) : null}
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          verticalAlign: "top",
                                          width: "90px",
                                          // display: 'flex',
                                          // justifyContent: 'space-between',
                                          // borderBottom:
                                          //   item.identifiersDetail.length ===
                                          //     subIndex + 1
                                          //     ? "none"
                                          //     : "",
                                        }}
                                      >
                                        {/* {item.identifiersDetail.length > 1 && */}
                                        <span style={{ display: 'flex', width: '70px', justifyContent: 'space-between' }}>
                                          {/* <Tooltip title={t('DELETE')}>
                                                                                <span onClick={(e) => { deleteMetaData(e, item, index, identifierRow.packageIndex) }} style={{ cursor: 'pointer' }}>
                                                                                    <DeleteIconNew />
                                                                                </span>
                                                                            </Tooltip> */}

                                          {identifierRow.status && identifierRow.status === 'ACTIVE' || identifierRow.status === 'IN_PROGRESS' ? null :
                                            identifierRow.statusDetail &&
                                            <IconButton
                                              style={{
                                                width: "28.63px",
                                                height: "28.63px",
                                              }}
                                              // disabled={
                                              //   item.identifiersDetail
                                              //     .length === 1
                                              // }
                                              onClick={(e) => {
                                                toogleExpandRow(
                                                  e,
                                                  item,
                                                  index,
                                                  identifierRow.packageIndex,
                                                );
                                              }}
                                              className="buttonSecondary"
                                            >
                                              {identifierRow.expand ?
                                                <KeyboardArrowUpIcon />
                                                :
                                                <KeyboardArrowDownIcon />
                                              }
                                            </IconButton>
                                          }
                                          <Tooltip title={props.t("DELETE")}>
                                            <IconButton
                                              style={{
                                                width: "28.63px",
                                                height: "28.63px",
                                              }}
                                              disabled={
                                                item.identifiersDetail
                                                  .length === 1
                                              }
                                              onClick={(e) => {
                                                deleteMetaData(
                                                  e,
                                                  item,
                                                  index,
                                                  identifierRow.packageIndex,
                                                );
                                              }}
                                              className="buttonSecondary"
                                            >
                                              <DeleteIconNew />
                                            </IconButton>
                                          </Tooltip>
                                        </span>
                                        {/* } */}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell
                                        style={{
                                          paddingBottom: 0,
                                          paddingTop: 0,
                                          border: identifierRow.expand ? "" : "none",
                                        }}
                                        colSpan={identifierRow.identifiers.length + 3}
                                        className="noPaddingClassOnColumn"
                                      >
                                        <Collapse
                                          in={identifierRow.expand}
                                          timeout="auto"
                                          unmountOnExit
                                        >
                                          {/* {identifierRow.statusDetail} */}
                                          <div style={{ whiteSpace: 'pre-wrap', padding: '14px', paddingLeft: '60px' }}>
                                            <pre style={{ margin: 0 }}>{JSON.stringify(deepParseJSON(identifierRow.statusDetail), null, 4)}</pre>
                                          </div>
                                        </Collapse>
                                      </TableCell>
                                    </TableRow>
                                  </React.Fragment>
                                ),
                              )}
                              {item.quantity < item.maxQuantity && (
                                <TableRow>
                                  <TableCell
                                    colSpan={
                                      3 +
                                      item.identifiersDetail[0].identifiers
                                        .length
                                    }
                                    align="right"
                                    style={{ paddingTop: 0 }}
                                  >
                                    <Button
                                      onClick={(e) => {
                                        addRowToOffering(e, item);
                                      }}
                                    >
                                      Add Row
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </div>
                    </React.Fragment>
                  );
                } else {
                  return null;
                }
              })}

            {/* </Table> */}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Box style={{ width: '100%' }}>
            <Grid container spacing={1} style={{ margin: 0 }}>
              <Grid
                item
                style={{ color: "#f44336", fontWeight: "bold" }}
                size={{
                  xs: 6,
                }}
              >
                {error || csvError}
              </Grid>
              <Grid
                item
                align="right"
                size={{
                  xs: 6,
                }}
              >
                <Button
                  style={{ marginRight: ".5rem" }}
                  onClick={handleClearClick}
                  className="buttonSecondary"
                >
                  {t("CLEAR_ALL")}
                </Button>
                <Button
                  style={{ marginRight: ".5rem" }}
                  onClick={handleImportClick}
                >
                  {t("IMPORT_CSV")}
                </Button>
                <input
                  accept=".csv"
                  style={{ display: "none" }}
                  id="csv-file-upload"
                  type="file"
                  ref={fileInputRef}
                  onChange={handleCSVUpload}
                />
                <Button onClick={() => submitForm()}>{t("SAVE")}</Button>
              </Grid>
            </Grid>
          </Box>
        </DialogActions>
      </Dialog>
      {/* warning dialog for import csv */}
      <Dialog
        open={showConfirmDialog}
        onClose={() => setShowConfirmDialog(false)}
      // PaperProps={{
      //     className: classess.resizablePaper
      // }}
      >
        <DialogTitle>{t("WARNING")}</DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            {t("IMPORT_CSV_WARNING_MESSAGE")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setShowConfirmDialog(false)}
            className="buttonSecondary"
          >
            {t("CANCEL")}
          </Button>
          <Button
            onClick={() => {
              setShowConfirmDialog(false);
              setError("");
              setCsvError("");
              // document.getElementById('csv-file-upload').click();
              if (fileInputRef.current) {
                fileInputRef.current.value = "";
              }
              fileInputRef.current.click();
            }}
          >
            {t("CONTINUE")}
          </Button>
        </DialogActions>
      </Dialog>
      {/* warning dialog for clear all */}
      <Dialog
        open={showClearConfirmDialog}
        onClose={() => setShowClearConfirmDialog(false)}
      >
        <DialogTitle>{t("WARNING")}</DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            {t("CLEAR_ALL_WARNING_MESSAGE")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setShowClearConfirmDialog(false)}
            className="buttonSecondary"
          >
            {t("CANCEL")}
          </Button>
          <Button
            onClick={() => {
              setShowClearConfirmDialog(false);
              clearAllFields();
            }}
          >
            {t("CONTINUE")}
          </Button>
        </DialogActions>
      </Dialog>
      {/* delete item warning dialog */}
      <Dialog
        open={showDeleteWarning}
        onClose={() => closeDeleteDialog(false)}
        maxWidth={"sm"}
        fullWidth={true}
      >
        <DialogTitle>{t("WARNING")}</DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            {t("DELETE_IDENTIFIER_ROW")} for{" "}
            {selectedProductToDelete.productName}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => closeDeleteDialog(false)}
            className="buttonSecondary"
          >
            {t("CANCEL")}
          </Button>
          <Button
            onClick={() => {
              closeDeleteDialog(true);
            }}
          >
            {t("YES")}
          </Button>
        </DialogActions>
      </Dialog>
      <Loader loading={loading} />
    </React.Fragment>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(PartialOrderProcessingDialog));
